// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1vjMl","filesListContainer":"PosDisputesFiles_filesListContainer__3wwx_","filesButton":"PosDisputesFiles_filesButton__1i9u8"};